import React from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import Recaptcha from 'reaptcha';
import classNames from 'classnames';

import sailthruSignUp from 'lib/sailthruSignUp';

import ButtonHoverAnimation from 'components/ButtonHoverAnimation';
import DefaultSuccessMessage from './DefaultSuccessMessage';

const VALID_EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class SignupInput extends React.Component {
  static propTypes = {
    newsletterId: PropTypes.string.isRequired,
    onError: PropTypes.func,
    onSubmit: PropTypes.func,
    renderOnSuccess: PropTypes.node,
    signupSource: PropTypes.string,
    sitekey: PropTypes.string.isRequired,
    vertical: PropTypes.string.isRequired,
  };

  static defaultProps = {
    onSubmit: Function.prototype,
    onError: Function.prototype,
    renderOnSuccess: <DefaultSuccessMessage />,
    signupSource: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      emailAddress: '',
      validEmailNote: false,
      submitted: false,
    };
  }

  handleChange = (e) => {
    const { value } = e.target;

    this.setState({
      emailAddress: value,
      validEmailNote: !!value.length && this.validEmail(value),
    });
  };

  handleEmailValidation = (e) => {
    const { value } = e.target;

    if (!this.validEmail(value)) {
      this.inputBoxEl.setCustomValidity(i18next.t('Invalid email'));
      this.formEl.reportValidity();
    } else {
      this.inputBoxEl.setCustomValidity('');
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();

    const { validEmailNote } = this.state;

    if (validEmailNote) {
      this.recaptchaInstance.execute();
    } else {
      this.handleEmailValidation(e);
    }
  };

  validEmail = (str) => VALID_EMAIL_REGEX.test(String(str).toLowerCase());

  captchaVerify = () => {
    const {
      newsletterId,
      signupSource,
      onSubmit,
      onError,
    } = this.props;
    const { emailAddress } = this.state;

    const signupValues = {
      id: emailAddress,
      key: 'email',
      email: emailAddress,
      lists: {
        Master: 1,
      },
      vars: {
        [newsletterId]: 1,
      },
      source: signupSource,
      onSuccess: ({ email }) => {
        this.setState({ submitted: true });
        onSubmit(email);
      },
      onError: () => {
        onError();
      },
    };

    sailthruSignUp(signupValues);
  };

  render() {
    const { renderOnSuccess, sitekey, vertical } = this.props;
    const { emailAddress, submitted } = this.state;
    const isToday = vertical === 'today';
    const isThink = vertical === 'think';

    const linkClassNames = classNames(
      'ttu signup-input__recaptcha-link',
    );

    const inputClasses = classNames(
      'pl5 pv3 flex-auto publico-hed',
      'signup-input__input',
      {
        'bg-knockout-primary b-none f6': isToday,
      },
    );

    const buttonClasses = classNames(
      'signup-input__signup-button',
      'ttu mt0 bg-knockout-primary f6 bw-1px',
      {
        'b-burst burst': isThink,
      },
    );

    return (
      <div className={classNames(vertical === 'dateline' && 'dateline')}>
        {!submitted ? (
          <form
            className={classNames('signup-input-form')}
            ref={(form) => {
              this.formEl = form;
            }}
          >
            <div className="signup-input__input-wrapper">
              <input
                className={inputClasses}
                name="emailAddress"
                onChange={this.handleChange}
                placeholder={i18next.t('Enter your email')}
                ref={(input) => {
                  this.inputBoxEl = input;
                }}
                value={emailAddress}
              />
            </div>
            <ButtonHoverAnimation
              additionalClasses={buttonClasses}
              id="email-subscribe-button"
              data-show_prompt="false"
              data-confirm_howl="false"
              onClick={this.handleSubmit}
              size="normal"
              title={i18next.t('Sign Up')}
              type="button"
            />
          </form>
        ) : (
          React.cloneElement(renderOnSuccess)
        )}
        <footer>
          <p
            className={classNames(
              'founders-mono f1 pt4 pt6-l mt0 mb0 ttu',
            )}
          >
            { i18next.t('This site is protected by recaptcha') }
            &nbsp;
            <span className="signup-input__recaptcha-links">
              <a
                className={linkClassNames}
                href="https://www.nbcuniversal.com/privacy"
                rel="noopener noreferrer"
                target="_blank"
              >
                { i18next.t('Privacy Policy') }
              </a>
              &nbsp;|&nbsp;
              <a
                className={linkClassNames}
                href="https://www.nbcuniversal.com/terms"
                rel="noopener noreferrer"
                target="_blank"
              >
                { i18next.t('Terms of Service') }
              </a>
            </span>
          </p>
        </footer>
        <>
          <Recaptcha
            ref={(instance) => {
              this.recaptchaInstance = instance;
            }}
            onVerify={this.captchaVerify}
            sitekey={sitekey}
            size="invisible"
          />
        </>
      </div>
    );
  }
}

export default SignupInput;
